import {PriceFunc, PriceElemsData, PriceSegment, getListPrice} from '@icc/price';
import {Injectable, Inject} from '@angular/core';
import {APP_CONFIG, AppConfig, AppConfigFactory} from '@icc/shared/config';;
import { Common } from '@icc/shared/helpers';
import { ColorsDefaultsService } from '@icc/construction-elements/configurator';
import { IccWindowColors } from '@icc/construction-elements/types';
import { Components } from '@icc/window-door/types';


@Injectable()
export class PriceDoorService {

    constructor(
        @Inject(APP_CONFIG) private config: AppConfigFactory,
        private colorsDefaultsService: ColorsDefaultsService,
    ) {}

    /**
     * Cena modelu drzwi
     * @param  {Object} model       Model
     * @param  {Object} colors      Kolory
     * @param  {Number} sashesCount Liczba skrzydeł
     * @return {Number}             Cena
     */
    priceDoorModel(model, colors: IccWindowColors, sashesCount, listPrice = false) {
        let field = 'price_bi_color';
        if (colors.frame.outer.type === 'white'
            && colors.frame.inner.type === 'white'
        ) {
            field = 'price_white';
        } else if (
            colors.frame.outer?.isCore
            || !colors.frame.inner?.isCore
        ) {
            field = 'price_one_color';
        } else {
            field = 'price_bi_color';
        }

        let price = 0;
        const listPriceEnableInMarket = this.config().IccConfig.Offer.listPrice ? this.config().listPriceEnableInMarket : true;
        const modelField = getListPrice(model, field, listPrice, listPriceEnableInMarket);
        if (Common.isObject(model) && Common.isDefined(modelField)) {
            price = parseFloat(modelField) * ~~sashesCount;
        }
        return price;
    }

    /**
     * Dodawanie ceny za model drzwi
     * @param  {Number} price         Cena
     * @param  {Array} PriceElems     Składowe ceny
     * @param  {Object} model         Model
     * @param  {Object} colors        Kolory
     * @param  {Number} sashesCount   Liczba skrzydeł
     * @param  {Object} NoPriceCauses Powody braku ceny
     * @return {Number}               Cena
     */
    @PriceFunc({
        shortName: 'doorModel',
        data: {
            model: 'conf.Model',
            colors: 'conf.Colors',
            sashesCount: 'conf.Sashes.length',
        }
    })
    suppDoorModel({PriceStack, PriceElems, NoPriceCauses, listPrice}: PriceElemsData, {model, colors, sashesCount}: {model, colors: IccWindowColors, sashesCount}): PriceSegment[] {
        if (this.config().IccConfig.Configurators.door.version > 1) {
            return [];
        }
        let supp = this.priceDoorModel(model, colors, sashesCount, listPrice);
        if (Common.isUndefined(supp) || supp === null || isNaN(supp)) {
            supp = NaN;
            NoPriceCauses.push('no price for model');
        } else {
            PriceElems.doorModel = {
                id           : model.id,
                name         : model.name,
                count        : sashesCount,
                price        : supp,
                // colorField   : getAccessoryPriceField(colors),
            };
        }

        return <PriceSegment[]>[{
            type: 'doorModel',
            baseValue: supp,
            value: supp,
            valueType: 'value',
            data: {
                id   : model.id,
                name : model.name,
                count: sashesCount,
            }
        }]
    }

    /**
     * Cena portalu drzwi
     * @param  {Object} portal       Portal
     * @return {Number}             Cena
     */
     // eslint-disable-next-line max-params
     getDoorPortalPrice(depth: number, leftWidth: number, rightWidth: number, upperHeight: number, surcharge: number, prices: any, listPrice: boolean) {
        const listPriceEnableInMarket = this.config().IccConfig.Offer.listPrice ? this.config().listPriceEnableInMarket : true;

        const depthPrices = depth ? (prices.find(p => p?.depth && p?.depth !== 'null' && p.length === depth)) || 0 : 0;
        const leftWidthPrices = (prices.find(p => p.length === leftWidth)) || 0;
        const rightWidthPrices = (prices.find(p => p.length === rightWidth)) || 0;
        const upperHeightPrices = (prices.find(p => p.length === upperHeight)) || 0;

        const depthPrice = depthPrices ? getListPrice(depthPrices, 'depth', listPrice, listPriceEnableInMarket) : 0;
        const leftWidthPrice = leftWidthPrices ? getListPrice(leftWidthPrices, 'left', listPrice, listPriceEnableInMarket) : 0;
        const rightWidthPrice = rightWidthPrices ? getListPrice(rightWidthPrices, 'right', listPrice, listPriceEnableInMarket) : 0;
        const upperHeightPrice = upperHeightPrices ? getListPrice(upperHeightPrices, 'upper', listPrice, listPriceEnableInMarket) : 0;

        const dimensionSum = (depthPrice + leftWidthPrice + rightWidthPrice + upperHeightPrice);

        let surchargePrice = 0;
        if (surcharge >= 1) {
            surchargePrice = dimensionSum * (surcharge/100);
        }

        const totalPrice = dimensionSum + surchargePrice;
        return totalPrice;
}

    /**
     * Dodawanie ceny za portal drzwi
     * @param  {Number} price         Cena
     * @param  {Array}  PriceElems    Składowe ceny
     * @param  {Object} portal        Portal
     * @param  {Object} NoPriceCauses Powody braku ceny
     * @return {Number}               Cena
     */
    @PriceFunc({
        shortName: 'doorPortal',
        data: {
            portal: 'conf.doorPortal',
            components: 'conf.Components',
        }
    })
    suppDoorPortal({PriceElems, NoPriceCauses, listPrice}: PriceElemsData, {portal, components}): PriceSegment[] {
        const hasPortal = portal && portal.id;

        if (!hasPortal) return [];
        if(components && !components.portal) {
            return [];
        }

        const { depth, leftWidth, rightWidth, upperHeight, surcharge, prices } = portal;

        let supp = this.getDoorPortalPrice(depth, leftWidth, rightWidth, upperHeight, surcharge, prices, listPrice);

        if (Common.isUndefined(supp) || supp === null || isNaN(supp)) {
            supp = NaN;
            NoPriceCauses.push('no price for door portal');
        } else {
            PriceElems.doorPortal = {
                id           : portal.id,
                name         : portal.name,
                price        : supp,
            };
        }

        return <PriceSegment[]>[{
            type: 'doorPortal',
            baseValue: supp,
            value: supp,
            valueType: 'value',
            data: {
                id   : portal.id,
                name : portal.name,
                portalLeftWidth     : portal.leftWidth,
                portalRightWidth    : portal.rightWidth,
                portalUpperHeight   : portal.upperHeight,
                portalWallThickness : portal.wallThickness
            }
        }]
    }

    @PriceFunc({
        shortName: 'doorSize',
        data: {
            doorSizes: 'data.doorSizes',
            sashSize: 'conf.doorSizes.sashSizeId',
            components: 'conf.Components',
        },
    })
    suppDoorSize(
        { listPrice }: PriceElemsData,
        { doorSizes, sashSize, components }: {doorSizes; sashSize; components: Components}
    ): PriceSegment[] {
        if (Common.isArray(doorSizes) && sashSize) {
            if(components && !components.activeSash) {
                return [];
            }
            const doorSize = doorSizes.find(
                s => Number(sashSize) === Number(s.id)
            );
            const listPriceEnableInMarket = this.config().IccConfig.Offer.listPrice ? this.config().listPriceEnableInMarket : true;
            const price = getListPrice(doorSize, 'price', listPrice, listPriceEnableInMarket);
            return [
                {
                    type: 'doorSize',
                    baseValue: !isNaN(price) ? 1 + price / 100 : null,
                    value: !isNaN(price) ? 1 + price / 100 : null,
                    valueType: 'percent',
                    data: {
                        sashSize: sashSize,
                    },
                },
            ] as PriceSegment[];
        }
        return [];
    }
}

